'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvSkipPrevious = function AvSkipPrevious(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 6h2v12H6zm3.5 6l8.5 6V6z' })
  );
};
AvSkipPrevious = (0, _pure2.default)(AvSkipPrevious);
AvSkipPrevious.displayName = 'AvSkipPrevious';

exports.default = AvSkipPrevious;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/av/skip-previous.js
 ** module id = 1230
 ** module chunks = 0
 **/